module.exports = __webpack_public_path__ + "img/bg-dashboard-purple.b369c4a2.png";